import { TextField } from '@mui/material';
import { OutlinedInputProps } from '@mui/material';
import { InputHTMLAttributes } from 'react';
import { FieldRenderProps, useForm } from 'react-final-form';
import { CountryData, PhoneInputProps } from 'react-phone-input-2';
import { useTranslation } from '../../modules/translation/TranslationContext';
import PhoneField from '../FormInputs/PhoneField/PhoneField';
import Field from './Field';

type RFFPhoneFieldProps = PhoneInputProps & {
  initialValue?: string;
  name: string;
  label: string;
};
/**
 * @deprecated React Final Form has been deprecated in the system.
 * Components based on RFF are no longer supported.
 * Please use <TextField /> or other updated alternatives.
 */
const RFFPhoneField = ({
  initialValue,
  name,
  onFocus: _onFocus,
  onChange: _onChange,
  onClick: _onClick,
  onMount: _onMount,
  ...other
}: RFFPhoneFieldProps) => {
  const { translate } = useTranslation();
  const form = useForm();

  return (
    <Field initialValue={initialValue} name={name}>
      {({
        input,
        meta,
        ...props
      }: FieldRenderProps<string, HTMLInputElement | HTMLTextAreaElement>) => (
        <TextField
          variant="standard"
          {...input}
          {...props}
          {...other}
          value={input.value}
          error={meta.error && meta.touched}
          onBlur={input.onBlur}
          onFocus={input.onFocus}
          onChange={input.onChange}
          helperText={meta.touched && meta.error && translate(meta.error)}
          slotProps={{
            // TODO: mesmo tratamento de CustomerContactsField:159 (tipos incompatíveis)
            input: {
              inputComponent: PhoneField as unknown as OutlinedInputProps['inputComponent'],
              inputProps: {
                onChange: (value: string, data: CountryData) => {
                  form.change('countryCode', data.dialCode);
                  input.onChange(value);
                },
              } as unknown as InputHTMLAttributes<HTMLInputElement>,
            },
            inputLabel: { shrink: true },
          }}
        />
      )}
    </Field>
  );
};

export default RFFPhoneField;
